import script from "./HeaderList.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderList.vue?vue&type=script&setup=true&lang=js"

import "./HeaderList.vue?vue&type=style&index=0&id=1ecfd63c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecfd63c"]])

export default __exports__